import duoToneIconData from "@/MansoqUI/icons/DuoTonePaths.json";
import iconData from "@/MansoqUI/icons/UniconPaths.json";
import "@/MansoqUI/icons/icon.css";

export type IconName = keyof typeof iconData | keyof typeof duoToneIconData;

export interface MansoqIconProps {
  icon: IconName;
  className?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  id?: string;
}

/**
 * ### MANSOQ's Official Icon Library.
 * @param className icon class name
 * @returns icon component
 * @example ```<MansoqIcon icon="l-hospital"/> ```
 *
 * @see [icon library](https://iconscout.com/unicons/)
 */
export default function MansoqIcon({
  id,
  icon,
  className,
  onClick,
}: MansoqIconProps) {
  // TODO: fill & strokeWidth are defined for only one icon
  // Rethink Implementation

  const requestedIcon = icon.startsWith("d-")
    ? duoToneIconData[icon as keyof typeof duoToneIconData]
    : iconData[icon as keyof typeof iconData];
  const resolvedIcon = requestedIcon ? icon : "d-health-worker";
  const isDuoTone = resolvedIcon.startsWith("d-");

  const [viewBox, path, fill, strokeWidth, secondaryPath] = (requestedIcon ??
    duoToneIconData["d-health-worker"]) as [
    number,
    string,
    boolean | undefined,
    number | undefined,
    string | undefined,
  ];

  const svgClassName = `mansoq-svg-icon__baseline ${className || ""}`.trim();

  return (
    <svg
      id={id}
      className={`mansoq-${resolvedIcon} ${svgClassName}`}
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      viewBox={`0 0 ${viewBox} ${viewBox}`}
    >
      <path
        d={path}
        fill={fill === false ? "none" : "currentColor"}
        stroke={fill === false ? "currentColor" : undefined}
        strokeWidth={fill === false ? strokeWidth : undefined}
      />
      {secondaryPath && (
        <path
          d={secondaryPath}
          fill={fill === false ? "none" : "currentColor"}
          stroke={fill === false ? "currentColor" : undefined}
          strokeWidth={fill === false ? strokeWidth : undefined}
          // TODO: Temp. hack until we properly abstract things
          opacity={isDuoTone ? 0.32 : 1}
        />
      )}
    </svg>
  );
}
